<template>
    <div class="portfolioStockList">
        <div v-if="aggregatedPortfolioStock.length>0" class="entryList">
            <div class="entriesHeader">
                <div class="entryHeader aleft">
                    <v-btn v-if="showExpand" @click="goToPortfolioOverview" icon small>
                        <font-awesome-icon :icon="icons.expand" class="fa-fw fa-lg"></font-awesome-icon>
                    </v-btn>
                </div>
                <div class="entryHeader eh-right aright">{{ $t("Home.dashboard.overview.portfolioStock.current") }}</div>
                <div class="entryHeader eh-center aright">
                    <v-btn @click="changeSortOrder({ by: 'changePercent' })" x-small text>{{ $t("Home.dashboard.overview.portfolioStock.todayChange") }} <font-awesome-icon v-if="sortByTodayChangeIcon" :icon="sortByTodayChangeIcon" class="fa-fw fa-xs"></font-awesome-icon></v-btn>
                    <v-btn @click="changeSortOrder({ by: 'dayChange' })" x-small text>{{ todayGainTitle }} <font-awesome-icon v-if="sortByTodayGainIcon" :icon="sortByTodayGainIcon" class="fa-fw fa-xs"></font-awesome-icon></v-btn>
                </div>
                <div class="entryHeader eh-right aright">
                    <v-btn @click="changeSortOrder({ by: 'totalProfitIncludingUnrealized' })" x-small text>{{ totalGainTitle }} <font-awesome-icon v-if="sortByTotalGainIcon" :icon="sortByTotalGainIcon" class="fa-fw fa-xs"></font-awesome-icon></v-btn>
                    <v-btn @click="changeSortOrder({ by: 'totalMaterializedGrossValueIncludingUnrealized' })" x-small text>{{ totalValueTitle }} <font-awesome-icon v-if="sortByTotalValueIcon" :icon="sortByTotalValueIcon" class="fa-fw fa-xs"></font-awesome-icon></v-btn>
                </div>
            </div>
            <div v-for="(entry, index) in sortedPortfolioStock" :key="index" class="entry" @click="showStock(entry)">
                <div class="entryPart ep-left">
                    <div class="entrySymbol">{{entry.symbol}}</div>
                    <div class="entryName">{{entry.companyName}}</div>
                </div>
                <div class="entryPart ep-right">
                    <StockPriceInfos :entry="stockPriceInfo(entry)"></StockPriceInfos>
                    <div class="entryName">{{ entry.remainingStockShareCount }} actions</div>
                </div>
                <div class="entryPart ep-center">
                    <StockPriceChange :stockChangeInfo="stockChangeInfo(entry)"></StockPriceChange>
                    <StockChange v-bind="dayChange(entry)"></StockChange>
                </div>
                <div class="entryPart ep-right">
                    <StockChange v-bind="totalChange(entry)"></StockChange>
                    <StockTotalChange v-if="false" :stock="entry" class="entryValue"></StockTotalChange>
                    <ValueWithCurrency v-bind="totalMarketValue(entry)" class="entryValue"></ValueWithCurrency>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { faArrowDown, faArrowUp, faExpand } from '@fortawesome/pro-light-svg-icons';
import ValueWithCurrency from '../controls/ValueWithCurrency.vue';
import StockChange from '../stocks/StockChange.vue';
import StockPriceChange from '../stocks/StockPriceChange.vue';
import StockPriceInfos from '../stocks/StockPriceInfos.vue';
import StockTotalChange from '../stocks/StockTotalChange.vue';
import userStockListMixin from '../userStockWatchingList/UserStockListMixin';
export default {
    props: {
        data: {
            type: Array,
            required: false,
            default: null
        },
        owner: {
            type: String,
            required: false,
            default: 'me'
        }
    },
    mixins: [userStockListMixin],
    data() {
        return {
            icons: {
                sortAsc: faArrowUp,
                sortDesc: faArrowDown,
                expand: faExpand
            },
            sortedPortfolioStock: [],
            sorter: {
                by: 'totalMaterializedGrossValueIncludingUnrealized',
                asc: false
            }
        }
    },
    computed: {
        showExpand() {
            return this.$vuetify.breakpoint.lgAndUp && this.owner === 'me';
        },
        todayGainTitle() {
            return this.$t("Home.dashboard.overview.portfolioStock.todayGain") + ` (${this.userPreferredCurrency})`;
        },
        totalGainTitle() {
            return this.$t("Home.dashboard.overview.portfolioStock.totalGain") + ` (${this.userPreferredCurrency})`;
        },
        totalValueTitle() {
            return this.$t("Home.dashboard.overview.portfolioStock.totalValue") + ` (${this.userPreferredCurrency})`;
        },
        aggregatedPortfolioStock() {
            return this.data ? this.data : []; //this.owner === 'me' ? this.$store.getters.aggregatedPortfolioStock : [];
        },
        sortByTodayChangeIcon() {
            return this.getSortIconByKey('changePercent');
        },
        sortByTodayGainIcon() {
            return this.getSortIconByKey('dayChange');
        },
        sortByTotalGainIcon() {
            return this.getSortIconByKey('totalProfitIncludingUnrealized');
        },
        sortByTotalValueIcon() {
            return this.getSortIconByKey('totalMaterializedGrossValueIncludingUnrealized');
        }
    },
    beforeMount() {
        this.sortAggregatedPortfolioStock({ by: this.sorter.by });
    },
    methods: {
        goToPortfolioOverview() {
            this.$router.push({ name: 'PortfoliosOverview' });
        },
        getSortIconByKey(key) {
            return this.sorter.by !== key ? null : this.sorter.asc ? this.icons.sortAsc : this.icons.sortDesc;
        },
        showStock(item) {
            this.$router.push({ name: 'Stock', params: { id: item.stockId } });
        },
        stockPriceInfo(stock) {
            if (!stock.signifiantStockDayEvolution) {
                return {
                    currency: '',
                    lastPrice: 0
                }
            }
            return {
                currency: stock.signifiantStockDayEvolution.currency.toUpperCase(),
                lastPrice: stock.signifiantStockDayEvolution.singleShareCurrentPrice
            }
        },
        stockChangeInfo(stock) {
            if (!stock.signifiantStockDayEvolution) {
                return {
                    changeAmount: 0,
                    changePercent: 0
                }
            }
            return {
                changeAmount: stock.signifiantStockDayEvolution.singleShareDayChange,
                changePercent: stock.signifiantStockDayEvolution.percent
            }
        },
        totalMarketValue(stock) {
            if (!stock) {
                return {
                    currency: '',
                    price: 0,
                    showCurrency: false
                }
            }
            return {
                currency: stock.currency,
                price: stock.userPositionDetails.totalMaterializedGrossValueIncludingUnrealized,
                showCurrency: false
            }
        },
        dayChange(stock) {
            return stock.totalDayChange;
        },
        totalChange(stock) {
            return stock.totalChange;
        },
        // getValueByPath(obj, path, key) {
        //     // path peut avoir plus d'un niveau, ex: 'statistics.normalizedWithPreferredCurrency'
        //     console.log('getValueByPath:', obj, path, key);
        //     return path.split('.').reduce((acc, k) => acc && acc[k], obj)[key];
        // },
        getValueByPath(obj, path, key) {
            // path peut avoir plus d'un niveau, ex: 'statistics.normalizedWithPreferredCurrency'
            const value = path.split('.').reduce((acc, k) => acc && acc[k] ? acc[k] : undefined, obj);
            return value ? value[key] : undefined;
        },
        changeSortOrder({ by }) {
            const asc = this.sorter.by === by ? !this.sorter.asc : false
            this.sortAggregatedPortfolioStock({ by, asc });
        },
        sortAggregatedPortfolioStock({ by, asc }) {
            if (!this.data) { return; }
            this.sorter = { by, asc };
            const part = 'signifiantStockDayEvolution';
            this.sortedPortfolioStock = [...this.data].sort((a, b) => {
                const va = this.getValueByPath(a, part, by);
                const vb = this.getValueByPath(b, part, by);
                if (va < vb) {
                    return asc ? -1 : 1;
                };
                if (va > vb) {
                    return asc ? 1 : -1;
                }
                return 0;
            });
        }
    },
    watch: {
        data: {
            handler() {
                this.sortAggregatedPortfolioStock({ by: this.sorter.by });
            },
            deep: true
        }
    },
    components: { StockPriceInfos, StockPriceChange, StockTotalChange, ValueWithCurrency, StockChange }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/breakpoints.scss";
.portfolioStockList {
    color: #000;
    background-color: #FFF;
    .entryList {
        display: flex;
        flex-direction: column;
        .entriesHeader {
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 0.6em;
            padding: 2px;
            background-color: var(--v-lightGrayBG-base);
            .entryHeader {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                gap: 2px;
                flex: 1;
                position: relative;
                &.eh-center {
                }
                &.aleft {
                    text-align: left;
                    align-items: flex-start;
                }
                &.aright {
                    text-align: right;
                }
                &.eh-actions {
                    text-align: right;
                    .addButtonMobile {
                        position: relative;
                        right: 0;
                        top: -15px;
                    }
                }
                ::v-deep .v-btn {
                    text-transform: none;
                    font-weight: normal;
                    letter-spacing: normal;
                    svg {
                        margin-left: 2px;
                    }
                }
            }
        }
        .entry {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 5px;
            border-bottom: solid 1px #EEE;
            cursor: pointer;
            &:hover {
                background-color: var(--agoraBG);
            }
            .entryPart {
                font-size: 0.8em;
                flex: 1;
                &.ep-left {}
                &.ep-center {
                    font-size: 0.7em;
                    text-align: right;
                }
                &.ep-right {
                    text-align: right;
                }
                .entrySymbol {
                    font-weight: bold;
                }
                .entryName {
                    font-size: 0.8em;
                    color: var(--midGray);
                }
                .entryValue {
                    font-size: 0.9em;
                    justify-content: flex-end;
                }
                .sdcLabel {
                    font-size: 0.8em;
                }
                ::v-deep .priceInfos {
                    justify-content: flex-end;
                    .currency{
                        font-size: 0.7em;
                    }
                }
            }
            @media screen and (max-width: $tablet) {
                & {
                    font-size: 0.8em;
                }
            }
        }
    }
}
</style>